import { render, staticRenderFns } from "./TemporalyClosed.vue?vue&type=template&id=8b3a9e66"
import script from "./TemporalyClosed.vue?vue&type=script&lang=js"
export * from "./TemporalyClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports